<template>
  <app-modal
    v-bind="$attrs"
    class="modal-container"
    title="ワンタイムURL発行確認"
  >
    <template v-slot:body="{ ok }">
      <!-- BODY -->
      <div class="modal-body pa-4">ワンタイムURLを送信しました。</div>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="ok" variant="outlined" color="primary">戻る</v-btn>
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "OneTimeUrlIssueModalComplete",
});
</script>
